<template>
  <div class="go-in">
    <banner title="走进尚亚" subtitle="ABOUT SHANGYA" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <!-- 公司简介 -->
        <div class="content-summary" v-reveal>
          <div class="summary-left">
            <p class="stitle">公司简介</p>
            <p class="estitle">ABOUT US</p>
            <div class="stitle-line"></div>
            <p class="scontent">
              山东尚亚信息科技有限公司成立于2015年10月，注册资本330万元，法定代表人薄凯达，
              公司位于山东省淄博市张店区。作为一家信息技术企业，公司主要从事互联网信息服务、
              互联网数据服务和互联网上网服务等业务。公司开发的家庭日常维修服务综合管理平台
              体现了其在信息化服务领域的业务布局。山东尚亚信息科技有限公司在2025年获得国家级
              科技型中小企业认定。公司在网站建设领域提供专业服务，覆盖济宁、德州等地区，
              具备定制开发和快速上线能力。山东省跨境电商产业快速发展，形成了政策链、贸易链和
              产业带融合的生态体系，为当地信息技术企业创造了有利环境。独立站服务市场需求增长明显，
              山东尚亚信息科技有限公司所处的技术服务领域受益于外贸企业数字化升级趋势。
            </p>
          </div>
          <div class="summary-right">
            <div class="summary-img-box">
              <img src="../assets/img/jianjietopmin.jpg" alt="尚亚信息公司环境" />
            </div>
          </div>
        </div>

        <div class="divider-custom">
          <div class="divider-line"></div>
          <div class="divider-dot">
            <i class="el-icon-arrow-down"></i>
          </div>
          <div class="divider-line"></div>
        </div>


        <!-- 企业文化 -->
        <div class="content-culture">
          <div class="culture-bg">
            <div class="section-header light" v-reveal>
              <h3>企业文化</h3>
              <p>CULTURE</p>
            </div>
            <div class="culture-items" v-reveal="90">
              <div class="culture-item">
                <div class="culture-number">01</div>
                <p>我们只专注一件事情——工程项目管理</p>
              </div>
              <div class="culture-item">
                <div class="culture-number">02</div>
                <p>确保工程无重大安全事故</p>
              </div>
              <div class="culture-item">
                <div class="culture-number">03</div>
                <p>确保工程施工单位无大面积返工</p>
              </div>
              <div class="culture-item">
                <div class="culture-number">04</div>
                <p>确保工程材料及设备无伪劣产品</p>
              </div>
              <div class="culture-item">
                <div class="culture-number">05</div>
                <p>确保工程管理留下痕迹、实施过程可追溯</p>
              </div>
            </div>
          </div>
        </div>


        <!-- 团队风采 -->
        <div class="content-team">
          <div class="section-header" v-reveal>
            <h3>团队风采</h3>
            <p>TEAM</p>
          </div>
          <div v-if="teamItem.length" class="team-carousel" v-reveal="90">
            <el-carousel :interval="4000" :type="isMobile ? '' : 'card'" :height="isMobile ? '240px' : '420px'">
              <el-carousel-item v-for="team in teamItem" :key="team.Id || team.Img">
                <div class="swiper-img" v-lazy:background-image="imgserver + team.Img"></div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-else-if="!loading" class="content-empty">团队内容正在更新中</div>
        </div>

        <!-- 合作伙伴 -->
        <div class="content-partner">
          <div class="section-header" v-reveal>
            <h3>合作伙伴</h3>
            <p>PARTNERS</p>
          </div>
          <div v-if="partnerImg.length" class="partner-grid" v-reveal="90">
            <div class="partner-item" v-for="partner in partnerImg" :key="partner.Id || partner.Img">
              <img v-lazy="imgserver + partner.Img" :alt="partner.Name || partner.Title || '合作伙伴'" />
            </div>
          </div>
          <div v-else-if="!loading" class="content-empty">合作伙伴内容正在更新中</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: { Banner },
  data() {
    return {
      loading: true,
      isMobile: false,
      partnerImg: [],
      teamItem: []
    };
  },
  mounted() {
    this.updateViewport();
    window.addEventListener("resize", this.updateViewport);
    this.loadPageData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateViewport);
  },
  methods: {
    updateViewport() {
      this.isMobile = window.innerWidth <= 768;
    },
    loadPageData() {
      this.loading = true;
      this.$http
        .all([
          this.$http.get("Enterprise/GetEnterpriseAll"),
          this.$http.get("Team/GetTeamAll")
        ])
        .then(
          this.$http.spread((responseEnterprise, responseTeam) => {
            this.partnerImg = Array.isArray(responseEnterprise.data)
              ? responseEnterprise.data
              : [];
            this.teamItem = Array.isArray(responseTeam.data) ? responseTeam.data : [];
          })
        )
        .catch(error => {
          this.partnerImg = [];
          this.teamItem = [];
          window.console.warn("Failed to load company page data", error);
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.go-in {
  width: 100%;
  min-height: 100vh;
  background: #f0f4f8;
  position: relative;
  overflow: hidden;
}

.section {
  width: 100%;

  &-content {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 3%;
  }
}

// ===== 公共区块标题 =====
.section-header {
  text-align: center;
  margin-bottom: 50px;

  h3 {
    font-size: var(--text-h2);
    font-weight: 700;
    color: var(--ink-950);
    margin-bottom: 6px;
    letter-spacing: var(--tracking-cjk);
  }
  p {
    font-size: var(--text-eyebrow);
    font-weight: 700;
    color: var(--ink-400);
    letter-spacing: var(--tracking-eyebrow);
    text-transform: uppercase;
  }

  &.light {
    h3, p {
      color: #fff;
    }
  }
}

// ===== 公司简介 =====
.content-summary {
  display: flex;
  align-items: center;
  gap: 80px;
  padding: 80px 0 50px;

  .summary-left {
    flex: 1;

    .stitle {
      font-size: var(--text-h2);
      font-weight: 700;
      color: var(--ink-950);
      letter-spacing: var(--tracking-cjk);
      margin-bottom: 4px;
    }
    .estitle {
      font-size: var(--text-eyebrow);
      font-weight: 700;
      color: var(--ink-400);
      letter-spacing: var(--tracking-eyebrow);
      text-transform: uppercase;
      margin-bottom: 16px;
    }
    .stitle-line {
      width: 48px;
      height: 3px;
      background: linear-gradient(90deg, var(--brand-600), var(--accent-500));
      border-radius: 2px;
      margin-bottom: 28px;
    }
    .scontent {
      font-size: 15px;
      color: var(--ink-600);
      line-height: 2;
      text-indent: 2em;
    }
  }

  .summary-right {
    flex-shrink: 0;

    .summary-img-box {
      width: 420px;
      height: 320px;
      border-radius: var(--radius-md);
      overflow: hidden;
      box-shadow: var(--shadow-md);
      position: relative;

      &::after {
        content: '';
        position: absolute;
        inset: 0;
        border: 2px solid rgba(22, 121, 173, 0.16);
        border-radius: var(--radius-md);
        pointer-events: none;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform var(--duration-slow) var(--ease-out);
      }

      &:hover img {
        transform: scale(1.04);
      }
    }
  }
}

// ===== 分割线 =====
.divider-custom {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 20px 0;

  .divider-line {
    width: 80px;
    height: 1px;
    background: var(--line);
  }
  .divider-dot {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--brand-600);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 16px;

    i {
      color: #fff;
      font-size: 14px;
    }
  }
}

// ===== 企业文化 =====
.content-culture {
  margin: 0 -3%;
  padding: 0;

  .culture-bg {
    background: linear-gradient(135deg, var(--brand-900) 0%, var(--brand-600) 100%);
    padding: var(--section-space) 3%;
  }

  .culture-items {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 24px;
    max-width: 1200px;
    margin: 0 auto;

    .culture-item {
      text-align: center;
      padding: 32px 20px;
      background: var(--glass-fill);
      border-radius: var(--radius-md);
      backdrop-filter: blur(4px);
      transition: background var(--duration-base) ease, transform var(--duration-base) var(--ease-out);
      border: 1px solid var(--glass-border);

      &:hover {
        background: var(--glass-fill-hover);
        transform: translateY(var(--hover-lift));
      }

      .culture-number {
        font-size: 36px;
        font-weight: 800;
        color: rgba(255, 255, 255, 0.25);
        margin-bottom: 12px;
        letter-spacing: 2px;
      }

      p {
        color: rgba(255, 255, 255, 0.9);
        font-size: 15px;
        line-height: 1.6;
        letter-spacing: 1px;
      }
    }
  }
}

// ===== 团队风采 =====
.content-team {
  padding: clamp(32px, 4vw, 48px) 0 var(--section-space);

  .team-carousel {
    max-width: 1000px;
    margin: 0 auto;

    .swiper-img {
      height: 420px;
      background: no-repeat center;
      background-size: cover;
      border-radius: var(--radius-md);
    }
  }
}

// ===== 合作伙伴 =====
.content-partner {
  padding: clamp(32px, 4vw, 48px) 0 var(--section-space);

  .partner-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    max-width: 1000px;
    margin: 0 auto;

    .partner-item {
      width: 120px;
      height: 80px;
      background: #fff;
      border: 1px solid var(--line);
      border-radius: var(--radius-sm);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px;
      box-shadow: var(--shadow-xs);
      transition: transform var(--duration-base) var(--ease-out), box-shadow var(--duration-base) ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: var(--shadow-sm);
      }

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
  }
}


.content-empty {
  display: grid;
  place-items: center;
  min-height: 180px;
  color: var(--color-ink-muted);
  background: rgba(255, 255, 255, 0.78);
  border: 1px dashed rgba(18, 112, 180, 0.24);
  border-radius: var(--radius-md);
}

@media (max-width: 1024px) {
  .content-summary {
    flex-direction: column;
    gap: 40px;

    .summary-right .summary-img-box {
      width: 100%;
      max-width: 500px;
      height: 280px;
    }
  }
  .culture-items {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .content-summary {
    padding: 50px 0 30px;
  }
  .culture-items {
    grid-template-columns: 1fr;
  }
}


@media (max-width: 768px) {
  .go-in {
    overflow: visible;
  }

  .section-content {
    width: 100%;
    padding: 0 var(--mobile-gutter);
  }

  .section-header {
    margin-bottom: 28px;
  }

  .section-header h3 {
    font-size: 26px;
  }

  .content-summary {
    padding: 42px 0 30px;
    gap: 26px;
    flex-direction: column;
  }

  .content-summary .summary-left .stitle {
    font-size: 26px;
  }

  .content-summary .summary-left .scontent {
    line-height: 1.85;
    overflow-wrap: anywhere;
  }

  .content-summary .summary-right,
  .content-summary .summary-right .summary-img-box {
    width: 100%;
  }

  .content-summary .summary-right .summary-img-box {
    height: auto;
    aspect-ratio: 4 / 3;
  }

  .content-culture {
    margin-left: calc(var(--mobile-gutter) * -1);
    margin-right: calc(var(--mobile-gutter) * -1);
  }

  .content-culture .culture-bg {
    padding: 42px var(--mobile-gutter);
  }

  .content-culture .culture-items {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .content-culture .culture-item {
    padding: 20px;
  }

  .content-team,
  .content-partner {
    padding: 42px 0;
  }

  .content-team .team-carousel .swiper-img {
    height: 250px;
  }

  .content-team ::v-deep .el-carousel__container,
  .content-team ::v-deep .el-carousel__container {
    height: 250px !important;
  }

  .content-partner .partner-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .content-partner .partner-grid .partner-item {
    width: 100%;
    height: 76px;
  }

}
</style>
